import SentencesGroup from '@pretto/bricks/app/sentences/components/SentencesGroup'
import ButtonComponent from '@pretto/bricks/components/buttons/Button'
import { breakpoints, g } from '@pretto/bricks/components/layout'
import BaseTypo from '@pretto/bricks/components/typography/BaseTypo'

import { CheckHandwrite } from '@pretto/picto'

import styled, { css } from 'styled-components'

export const CookiesAlert = styled(BaseTypo).attrs({ typo: 'caption' })`
  margin: 0 ${g(2)} ${g(1)};
  color: ${({ theme }) => theme.colors.neutral2};

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-left: ${g(3)};
    margin-right: ${g(3)};
  }
  @media screen and (min-width: ${breakpoints.laptop}) {
    margin-left: 0;
    margin-right: 0;
  }
`
export const PrivacyLink = styled.a`
  text-decoration: underline;
`
export const Sentences = styled(SentencesGroup)`
  margin-bottom: ${g(3)};
  margin-left: ${g(2)};
  margin-right: ${g(2)};

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-left: ${g(3)};
    margin-right: ${g(3)};
  }
  @media screen and (min-width: ${breakpoints.laptop}) {
    margin-left: 0;
    margin-right: 0;
  }
`
export const Button = styled(ButtonComponent).attrs({ type: 'button' })`
  display: block;
  width: calc(100% - ${g(4)});
  margin: 0 ${g(2)};

  @media screen and (min-width: ${breakpoints.tablet}) {
    width: auto;
    margin-left: ${g(3)};
    margin-right: ${g(3)};
  }

  @media screen and (min-width: ${breakpoints.laptop}) {
    margin-left: 0;
    margin-right: 0;
  }
`
export const Container = styled.div`
  padding: ${g(2)} 0;
  @media screen and (min-width: ${breakpoints.tablet}) {
    padding: ${g(3)} 0;
  }
  @media screen and (min-width: ${breakpoints.laptop}) {
    padding: ${g(3)};
  }
`
export const Tabs = styled.div`
  display: flex;
  justify-content: stretch;
`
export const Tab = styled(BaseTypo).attrs({
  forwardedAs: 'button',
  type: 'button',
  typo: 'link',
})`
  background-color: ${({ theme }) => theme.colors.white};
  flex-grow: 1;
  padding: ${g(3)} ${g(1)};
  text-align: center;
  transition: background-color 150ms ease-in-out;
  white-space: nowrap;
  position: relative;

  &:first-child {
    border-top-left-radius: ${g(1)};
  }

  &:last-child {
    border-top-right-radius: ${g(1)};
  }

  &:focus {
    outline-style: solid;
    outline-color: transparent;

    &:after {
      border-radius: inherit;
      position: absolute;
      content: '';
      top: -1px;
      right: -1px;
      bottom: -1px;
      left: -1px;
      border: 1px dashed ${({ theme }) => theme.colors.accent1};
      z-index: 1;
    }
  }

  ${({ $isActive }) =>
    !$isActive &&
    css`
      text-decoration: underline;
      background-color: ${({ theme }) => theme.colors.neutral4};
      cursor: pointer;

      &:hover {
        color: ${({ theme }) => theme.colors.neutral1Hover};
      }
    `}
`
export const List = styled.ul`
  margin: ${g(3)} ${g(2)} 0;

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin: ${g(4)} ${g(3)} 0;
  }
  @media screen and (min-width: ${breakpoints.laptop}) {
    margin-left: 0;
    margin-right: 0;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
`
export const Item = styled(BaseTypo).attrs({ forwardedAs: 'li', typo: 'caption' })`
  margin-bottom: ${g(1)};
  display: flex;
  align-items: flex-start;
`
export const ItemIcon = styled(CheckHandwrite)`
  width: ${g(3)};
  height: ${g(3)};
  transform: translateY(${g(-0.5)});
`
